import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { useBootstrapTooltips } from '../../utils/useBootstrapTooltips';
function getRegimeDisplay(vessel) {
    const regime = vessel.Regime || '';
    const enabledRegimes = [];
    if (vessel.IsOpa90) {
        enabledRegimes.push('+OPA 90');
    }
    if (vessel.IsManilaExceptionsEnabled) {
        enabledRegimes.push('+Manila');
    }
    if (vessel.IsJapanExceptionsEnabled) {
        enabledRegimes.push('+Japan');
    }
    if (enabledRegimes.length === 0) {
        return regime || 'N/A';
    }
    return `${regime} (${enabledRegimes.join(' ')})`;
}
function formatDateOrNA(value) {
    if (!value) {
        return 'never';
    }
    return new Date(value).toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
}
export function VesselOperationCard({ vessel }) {
    const containerRef = useRef(null);
    useBootstrapTooltips(containerRef, [vessel]);
    return (_jsxs("div", { className: "card shadow mb-3", ref: containerRef, children: [_jsx("h2", { className: "card-header" }), _jsxs("div", { className: "card-body", children: [vessel.LastUpdate && (_jsxs("div", { className: "d-flex flex-wrap align-items-center gap-2 mb-3", children: [_jsx("span", { className: "fw-bold", "data-bs-toggle": "tooltip", "data-bs-placement": "top", title: "Flag", children: vessel.Flag || 'N/A' }), _jsx("span", { children: "\u00B7" }), _jsx("span", { "data-bs-toggle": "tooltip", "data-bs-placement": "top", title: "Regime", children: getRegimeDisplay(vessel) }), _jsx("span", { children: "\u00B7" }), _jsx("span", { "data-bs-toggle": "tooltip", "data-bs-placement": "top", title: "Vessel type", children: vessel.VesselType || 'N/A' }), _jsx("span", { children: "\u00B7" }), _jsxs("span", { children: ["Crew complement ", _jsx("span", { className: "fw-bold", children: vessel.CrewComplement ?? 'N/A' })] }), _jsx("span", { children: "\u00B7" }), _jsx("span", { "data-bs-toggle": "tooltip", "data-bs-placement": "top", title: "Time zone", children: vessel.TimeZone || 'N/A' }), _jsx("span", { children: "\u00B7" }), _jsx("span", { "data-bs-toggle": "tooltip", "data-bs-placement": "top", title: "Language", children: vessel.Language || 'N/A' })] })), _jsxs("div", { className: "d-flex flex-wrap align-items-center gap-2", children: [_jsx("i", { className: "fa fa-clock-o" }), _jsxs("span", { children: ["Last update: ", _jsx("span", { className: "fw-bold", children: formatDateOrNA(vessel.LastUpdate) })] })] })] })] }));
}
